import GeneralSettings from "./generalSettings";
import { Integration } from "/app/src/models";

/**
 * Settings component renders the general settings for a given integration.
 * @param {{ integration: Integration }} props - The component props.
 * @param {Integration} props.integration - The integration object to configure.
 * @returns {JSX.Element} The rendered GeneralSettings component.
 */
export default function Settings({
  integration,
}: {
  integration: Integration;
}) {
  return <GeneralSettings integration={integration} />;
}
